module.exports = __webpack_public_path__ + "img/ic_user.c6f2534a.png";